<template>
  <b-modal
    :visible="showModal"
    title="Confirmar exclusão de cliente"
    header-bg-variant="danger"
    header-text-variant="white"
    centered
    no-close-on-backdrop
    @hide="$emit('hide')"
  >
    <div v-if="!resultado">
      <p class="mb-2">
        Você está prestes a excluir o cliente:
      </p>
      <ul class="mb-3">
        <li><b>Nome:</b> {{ cliente && cliente.nomeCliente }}</li>
        <li><b>E-mail:</b> {{ cliente && cliente.emailCliente }}</li>
        <li><b>CPF:</b> {{ cliente && cliente.cpfCliente }}</li>
      </ul>
      <div class="alert alert-danger mb-3">
        <strong>Atenção:</strong> essa ação é <strong>irreversível</strong> e irá excluir
        <strong>todos os dados relacionados ao cliente</strong> (seguros, registros, assinaturas, cobranças, etc.).
      </div>
      <div class="form-group mb-0">
        <label for="motivo-exclusao"><strong>Motivo da exclusão</strong> <span class="text-danger">*</span></label>
        <textarea
          id="motivo-exclusao"
          class="form-control"
          rows="3"
          v-model="motivo"
          placeholder="Descreva o motivo da exclusão..."
          :disabled="loading"
        ></textarea>
      </div>
    </div>

    <div v-if="resultado && resultado.sucesso">
      <div class="alert alert-success">
        <strong>{{ resultado.mensagem }}</strong>
      </div>
      <p class="mb-1"><b>Cliente excluído:</b> {{ resultado.nomeCliente }}</p>
      <p class="mb-2"><b>Entidades afetadas:</b></p>
      <ul class="mb-0">
        <li v-for="(item, index) in resultado.entidadesAfetadas" :key="index">{{ item }}</li>
      </ul>
    </div>

    <div v-if="resultado && !resultado.sucesso">
      <div class="alert alert-danger">
        <p
          v-for="(erro, index) in resultado.erros"
          :key="index"
          class="mb-1"
          style="white-space: pre-line;"
          v-html="linkificar(erro)"
        ></p>
      </div>
    </div>

    <template #modal-footer>
      <div v-if="!resultado" class="w-100 d-flex justify-content-end">
        <b-button variant="secondary" class="mr-2" @click="$emit('hide')" :disabled="loading">
          Cancelar
        </b-button>
        <b-button variant="danger" @click="confirmar" :disabled="loading">
          <span v-if="!loading">Sim, excluir cliente</span>
          <span v-else>Aguarde...</span>
        </b-button>
      </div>
      <div v-else class="w-100 d-flex justify-content-end">
        <b-button variant="secondary" @click="$emit('hide')">Fechar</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import axios from "axios";
import config from "../../config";
import auth from "../../auth";
import captureError from "../../helpers/captureError";

export default {
  props: {
    showModal: { type: Boolean, default: false },
    cliente: { type: Object, default: null },
  },
  data() {
    return {
      loading: false,
      resultado: null,
      motivo: "",
    };
  },
  watch: {
    showModal(val) {
      if (val) {
        this.resultado = null;
        this.loading = false;
        this.motivo = "";
      }
    },
  },
  methods: {
    linkificar(texto) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return texto
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');
    },

    async confirmar() {
      if (!this.cliente) return;

      if (!this.motivo || !this.motivo.trim()) {
        this.$bvToast.toast("Informe o motivo da exclusão antes de continuar.", {
          title: "Campo obrigatório",
          variant: "warning",
          solid: true,
        });
        return;
      }

      this.loading = true;

      const userInfo = auth.getUserInfo();
      const payload = {};
      if (this.cliente.emailCliente) payload.email = this.cliente.emailCliente;
      if (this.cliente.cpfCliente) payload.cpf = this.cliente.cpfCliente;
      payload.idUsuarioAdm = userInfo ? userInfo.id : null;
      payload.motivo = this.motivo.trim();

      try {
        const response = await axios.delete(`${config.API_URLV2}/cliente/excluir`, {
          headers: {
            Authorization: `Bearer ${userInfo ? userInfo.token : ""}`,
            "Content-Type": "application/json",
          },
          data: payload,
        });

        const data = response.data;
        // API retorna direto sem envelope quando sucesso
        if (data && data.mensagem && data.idCliente) {
          this.resultado = { sucesso: true, ...data };
        } else if (data && typeof data.sucesso === 'boolean') {
          this.resultado = data;
        } else {
          this.resultado = { sucesso: true, ...data };
        }
      } catch (error) {
        const apiData = error.response && error.response.data;
        if (apiData && Array.isArray(apiData.erros) && apiData.erros.length > 0) {
          this.resultado = {
            sucesso: false,
            erros: apiData.erros,
            data: null,
          };
        } else if (apiData && typeof apiData === 'object' && !apiData.sucesso) {
          this.resultado = apiData;
        } else {
          captureError(error);
          this.resultado = {
            sucesso: false,
            erros: ["Erro ao comunicar com o servidor. Tente novamente mais tarde."],
            data: null,
          };
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
